import { Instagram, Facebook } from "lucide-react";

export const INSTAGRAM_URL = "https://www.instagram.com/rabitsch.supporter/";
export const FACEBOOK_URL =
    "https://www.facebook.com/people/rabitschsupporter/61572340196508/";

export default function SocialLinks({ className = "", variant = "default" }) {
    const base =
        variant === "light"
            ? "text-zinc-200 hover:text-[var(--rb-primary)]"
            : "text-zinc-400 hover:text-[var(--rb-secondary)]";
    return (
        <div className={`flex items-center gap-3 ${className}`} data-testid="social-links">
            <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noreferrer noopener"
                aria-label="Instagram"
                data-testid="social-instagram"
                className={`w-10 h-10 grid place-items-center border border-white/10 hover:border-[var(--rb-primary)] transition-colors ${base}`}
            >
                <Instagram className="w-4 h-4" strokeWidth={1.6} />
            </a>
            <a
                href={FACEBOOK_URL}
                target="_blank"
                rel="noreferrer noopener"
                aria-label="Facebook"
                data-testid="social-facebook"
                className={`w-10 h-10 grid place-items-center border border-white/10 hover:border-[var(--rb-primary)] transition-colors ${base}`}
            >
                <Facebook className="w-4 h-4" strokeWidth={1.6} />
            </a>
        </div>
    );
}
